import { MASK_PLACEHOLDER_PREVIEW_IMG_SRC } from 'components/VisualStudioPlayground/Shapes/MaskShape/constants'
import { useId } from 'react'

export const SixPointStar = () => {
  const imageId = useId()
  const patternId = useId()

  return (
    <svg width="76" viewBox="0 0 76 88" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M38.0605 0.0172424L50.7037 21.9168H75.992L63.3478 43.8163L75.992 65.7168H50.7037L38.0605 87.6163L25.4163 65.7168H0.128952L12.7722 43.8163L0.128952 21.9168H25.4163L38.0605 0.0172424Z"
        fill={`url(#${patternId})`}
        fillOpacity="0.6"
      />
      <defs>
        <pattern id={patternId} patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref={`#${imageId}`} transform="matrix(0.0110972 0 0 0.0111111 0.000626541 0)" />
        </pattern>
        <image id={imageId} width="90" height="90" xlinkHref={MASK_PLACEHOLDER_PREVIEW_IMG_SRC} />
      </defs>
    </svg>
  )
}
